import React from 'react';

import { DarkSkeleton } from '@eika/skeleton';

import './TransactionListSkeleton.scss';

interface Props {
    count?: number;
}

const TransactionListSkeleton = ({ count = 1 }: Props): JSX.Element => (
    <div className="transaction-details-skeleton">
        <div className="sgw-transaction-list ">
            <DarkSkeleton className="month-year-label" width={40} height={16} />
            {Array.from(Array(count)).map((_, index) => (
                // eslint-disable-next-line react/no-array-index-key
                <div className="transaction-details" key={`skeleton-transaction-details-${index}`}>
                    <DarkSkeleton height={16} />
                </div>
            ))}
        </div>
    </div>
);

export default TransactionListSkeleton;
